import { parseSync, stringify } from 'svgson';

export const transformSVG = (svg, id, title) => {
	const svgRoot = parseSync(svg);
	const svgTitle = {
		name: 'title',
		type: 'element',
		value: title,
		attributes: {
			id: `${id}--title`
        },
        children:[]
    };
    const svgDescription = {
		name: 'desc',
		type: 'element',
		value: title,
		attributes: {
			id: `${id}--desc`
		},
        children:[]
    };

    svgRoot.children.push(svgTitle);
    svgRoot.children.push(svgDescription);
    svgRoot.attributes = {...svgRoot.attributes, 'aria-labelledby': `${id}--title`};

    return stringify(svgRoot, {selfClose: false});
};
